import axios from 'axios'; /* TODO: Setup and use Axios API instance */
import { endpoint, API_BASE_URL, PROFESSIONAL_API_ENDPOINTS } from '@utils/api/endpoints';

export default {
	namespaced: true,

	actions: {
		async LoadTawkHash({ rootGetters }) {
			try {
				const url = endpoint(API_BASE_URL, PROFESSIONAL_API_ENDPOINTS.TAWK_HASH_REQUEST);
				const results = await axios.post(url, null, { headers: { Authorization: rootGetters.jwtToken } });
				if (!results.data) throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: 'Failed to load hash' });
				return results.data;
			} catch (err) {
				throw window.$Error(window.$ERROR.ERR_REQUEST_FAILED, { parent: err });
			}
		},
	},
};
